// plugins/vuetify.ts

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VApp: {
      fontFamily: 'Noto Sans KR',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#2E7D32',
          secondary: '#1565C0',
          accent: '#FF6F00',
          error: '#D32F2F',
          info: '#0288D1',
          success: '#388E3C',
          warning: '#F57C00',
          background: '#F0F4F8',
        },
      },
    },
  },
})



